import type { SimulationRun } from '@k-ucap/shared';
import type { SimulationRunRepository } from './RepositoryInterfaces.js';

const runs: Map<string, SimulationRun> = new Map();

export class InMemorySimulationRunRepository implements SimulationRunRepository {
  async findAll(): Promise<SimulationRun[]> {
    return Array.from(runs.values()).sort((a, b) => b.startedAt.localeCompare(a.startedAt));
  }

  async findById(id: string): Promise<SimulationRun | undefined> {
    return runs.get(id);
  }

  async findByProjectId(projectId: string): Promise<SimulationRun[]> {
    return Array.from(runs.values())
      .filter((r) => r.projectId === projectId)
      .sort((a, b) => b.startedAt.localeCompare(a.startedAt));
  }

  async findBySimulationTestId(simulationTestId: string): Promise<SimulationRun[]> {
    return Array.from(runs.values())
      .filter((r) => r.simulationTestId === simulationTestId)
      .sort((a, b) => b.startedAt.localeCompare(a.startedAt));
  }

  async save(run: SimulationRun): Promise<SimulationRun> {
    runs.set(run.id, run);
    return run;
  }

  async delete(id: string): Promise<void> {
    runs.delete(id);
  }
}

export const createInMemorySimulationRunRepository = (): InMemorySimulationRunRepository =>
  new InMemorySimulationRunRepository();
